import type { HomeLink } from "@/contracts";

// O destino é um objeto de navegação tipado, nunca uma URL fornecida livremente.
export function badgeHomeDestination(link: HomeLink) {
  switch (link.target) {
    case "overview":
      return { to: "/" as const };
    case "feed":
      return { to: "/feed" as const };
    case "messages":
      return { to: "/messages" as const };
    case "ranking":
      return { to: "/ranking" as const };
    case "showcase":
      return link.id
        ? { to: "/showcase/$id" as const, params: { id: link.id } }
        : { to: "/showcase" as const };
    case "courses":
      return link.id
        ? { to: "/courses/$id" as const, params: { id: link.id } }
        : { to: "/courses" as const };
    case "spaces":
      return link.id
        ? { to: "/spaces/$id" as const, params: { id: link.id } }
        : { to: "/spaces" as const };
  }
}
